import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './css/Button.scss';
import Icon from './Icon';
import classNames from 'classnames';
import {Link} from 'react-router-dom';

export default class Button extends Component {
    static propTypes = {
        block: PropTypes.bool,
        standalone: PropTypes.bool,
        children: PropTypes.node,
        className: PropTypes.string,
        link: PropTypes.bool,
        loading: PropTypes.bool,
        emphasis: PropTypes.oneOf(['default', 'primary', 'secondary', 'success', 'danger', 'warning', 'deactivate']),
        size: PropTypes.oneOf(['small']),
    }

    static defaultProps = {
        block: false,
        standalone: false,
        link: false,
        loading: false,
        emphasis: 'default',
    }

    render() {
        const {className, block, standalone, loading, emphasis, children, link, size, ...props} = this.props;
        const spacing = loading;

        const classes = classNames(className, styles.button, styles[emphasis], styles[size], {
            [styles.block]: block,
            [styles.standalone]: standalone,
        });

        if ((!props.to && props.href) || props.href) {
            return <a href={props.href} className={classes}>{children}</a>;
        }

        return React.createElement(
            link ? Link : 'button',
            Object.assign({}, props, {className: classes}),
            [
                loading ? <Icon name='refresh' spin fixedWidth/> : null,
                spacing ? ' ' : null,
                children,
            ].map((v, k) => {
                if (v === null) {
                    return null;
                }
                return <span key={k}>{v}</span>;
            })
        );
    }
}
